<section class="content">
    <div class="card" style="padding: 25px;">
        <div class="container-fluid">
            <div class="row">
                <div class="col" style="font-size: 23px; font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                    {{ title }}
                </div>
            </div>

            <!-- Dropdowns and Radio Buttons -->
            <div class="form-row">
                <div class="col-2">
                    <mat-list-item class="primary-imenu-item" role="listitem">
                        <mat-form-field class="select-form"
                            style="border: 2px solid lightgrey; padding: 11px;  border-radius: 18px;margin-left:-15px">
                            <mat-label>Select business Name</mat-label>
                            <mat-select [(ngModel)]="selectbusinessgroup" (ngModelChange)="onbusinessselectname()">
                                <mat-option *ngFor="let business of business_types" [value]="business.id">{{
                                    business.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>


                <div class="col-2">
                    <mat-list-item class="primary-imenu-item" role="listitem">
                        <mat-form-field appearance="outline" style="padding: 0px;">
                            <mat-label>Booth Code</mat-label>
                            <input matInput placeholder="Enter booth code" [(ngModel)]="selectboothcode"
                                (ngModelChange)="onboothcodeselect()">
                        </mat-form-field>

                    </mat-list-item>
                </div>




                <div class="col-3 mt-4">
                    <mat-radio-group [(ngModel)]="selectedProductCategory" (ngModelChange)="onProductCategorySelect()">
                        <mat-radio-button value="milk" style="margin-right: 20px;">Milk & Fermented
                            Products</mat-radio-button>
                        <mat-radio-button value="byproduct">By Products</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="col-2">
                    <button mat-raised-button color="primary" (click)="fetchDetails()" type="button"
                        style="margin-top: 7px;">
                        Fetch Details
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="card" style="padding: 15px;" *ngIf="showDetailsCard">
        <div class="card-body">
            <h5 class="card-title">{{businessname}}</h5>
            <div class="container-fluid">
                <div class="card mt-4">
                    <div class="row">
                        <!-- Row for labels -->
                        <div class="col-md-3">
                            <p><strong>Credit Amount</strong></p>
                        </div>
                        <div class="col-md-3">
                            <p><strong>Payment Received</strong></p>
                        </div>
                        <div class="col-md-3">
                            <p><strong>Balance Amount</strong></p>
                        </div>
                    </div>

                    <!-- Row for corresponding values -->
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <p>{{ creditdata }}</p>
                        </div>
                        <div class="col-md-3">
                            <p>{{ receiveddata }}</p>
                        </div>
                        <div class="col-md-3">
                            <p>{{ balancedata }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="card" style="padding: 25px;" *ngIf="showDetailsCard">
        <div class="container-fluid">
            <!-- Toggle between Paid and Unpaid mode -->
            <div class="row">
                <div class="col">
                    <mat-button-toggle-group [(ngModel)]="selectedStatus" (ngModelChange)="filterBills()" exclusive
                        style="width:10%">
                        <mat-button-toggle value="Not paid">Unpaid</mat-button-toggle>
                        <mat-button-toggle value="Paid">Paid</mat-button-toggle>
                    </mat-button-toggle-group>

                </div>
            </div>
            <!-- Billing Details Table -->
            <div class="row mt-4">
                <div class="col">
                    <!-- Table to display the bills data -->
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Bill No.</th>
                                    <!-- For Paid Status -->
                                    <th *ngIf="selectedStatus === 'Paid'">Bill Amount</th>
                                    <th *ngIf="selectedStatus === 'Paid'">Payment Status</th>
                                    <!-- For Not Paid Status -->
                                    <th *ngIf="selectedStatus === 'Not paid'">Bill Amount</th>

                                    <th *ngIf="selectedStatus === 'Not paid'">Balance Amount</th>
                                    <th *ngIf="selectedStatus === 'Not paid'">Payment Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let bill of filteredBillDetails">
                                    <td>{{ bill.date | date:'yyyy-MM-dd' }}</td>
                                    <td>{{ bill.bill_no }}</td>
                                    <!-- For Paid Bills -->
                                    <td *ngIf="selectedStatus === 'Paid'">{{ bill.pay_amount
                                        }}</td>
                                    <td *ngIf="selectedStatus === 'Paid'">{{ bill.pay_status }}</td>
                                    <!-- For Not Paid Bills -->
                                    <td *ngIf="selectedStatus === 'Not paid'">{{ bill.bill_amount }}</td>
                                    <td *ngIf="selectedStatus === 'Not paid'">{{ bill.balence_amt }}</td>
                                    <td *ngIf="selectedStatus === 'Not paid'">{{ bill.Payment_status }}</td>
                                    <td>
                                        <button mat-icon-button color="primary" aria-label="Edit"
                                            (click)="editBill(bill)" title="Update" data-toggle="modal"
                                            data-target="#updateModal">
                                            <mat-icon>edit</mat-icon>
                                        </button>

                                        <button mat-icon-button color="primary" aria-label="View"
                                            (click)="viewBill(bill)" title="View" data-toggle="modal"
                                            data-target="#viewModal">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>



    <!-- Update Payment Modal -->
    <div class="modal fade" id="updateModal" tabindex="-1" aria-labelledby="updateModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="updateModalLabel">Update Payment Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="resetForm()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="paymentForm" (ngSubmit)="saveUpdate()">
                        <!-- NA Status Toggle -->
                        <div class="form-group">
                            <mat-slide-toggle formControlName="na_status" (change)="onToggleChange($event)">
                                Mark as Not Applicable (NA)
                            </mat-slide-toggle>
                        </div>

                        <!-- Other fields will only show if na_status is false -->
                        <div *ngIf="!paymentForm.get('na_status').value">
                            <!-- Payment Date -->
                            <div class="form-group">
                                <label for="paymentDate">Payment Date</label>
                                <input type="date" class="form-control" id="paymentDate" formControlName="paymentDate"
                                    max="{{today}}">
                                <div *ngIf="paymentForm.get('paymentDate').invalid && paymentForm.get('paymentDate').touched"
                                    class="text-danger">
                                    Payment Date is required and cannot be in the future.
                                </div>
                            </div>

                            <!-- Payment Amount -->
                            <div class="form-group">
                                <label for="paymentAmount">Payment Amount</label>
                                <input type="number" class="form-control" id="paymentAmount"
                                    formControlName="paymentAmount">
                                <div *ngIf="paymentForm.get('paymentAmount').invalid && paymentForm.get('paymentAmount').touched"
                                    class="text-danger">
                                    Payment Amount is required and cannot be greater than the bill amount.
                                </div>
                            </div>

                            <!-- Payment Mode using mat-select -->
                            <div class="form-group">
                                <mat-form-field appearance="fill">
                                    <mat-label>Payment Mode</mat-label>
                                    <mat-select formControlName="paymentMode">
                                        <mat-option *ngFor="let mode of paymentModes" [value]="mode.value">
                                            {{ mode.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="paymentForm.get('paymentMode').invalid && paymentForm.get('paymentMode').touched"
                                    class="text-danger">
                                    Payment Mode is required.
                                </div>
                            </div>

                            <!-- Payment Reference No (Required if not 'Cash') -->
                            <div class="form-group" *ngIf="paymentForm.get('paymentMode').value !== '2'">
                                <label for="refNo">Payment Reference No</label>
                                <input type="text" class="form-control" id="refNo" formControlName="refNo">
                                <div *ngIf="paymentForm.get('refNo').invalid && paymentForm.get('refNo').touched"
                                    class="text-danger">
                                    Payment Reference is required for Bank Transfer or Cheque.
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"
                        (click)="resetForm()">Close</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveUpdate()"
                        [disabled]="paymentForm.invalid && !paymentForm.value.na_status || paymentForm.value.paymentAmount > bill_amount && !paymentForm.value.na_status">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </div>




    <!-- View Details Modal -->
    <div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="viewModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg"> <!-- Add modal-lg class here -->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="viewModalLabel">View Payment Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Payment Details Table -->
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Bill No.</th>
                                    <th>Payment Mode</th>
                                    <th>Payment Amount</th>
                                    <th>Payment Reference</th>
                                    <th>Payment Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let detail of paymentDetails">
                                    <td>{{ detail.payment_date }}</td>
                                    <td>{{ detail.bill_number }}</td>
                                    <td>{{ detail.payment_mode }}</td>
                                    <td>{{ detail.payment_amount }}</td>
                                    <td>{{ detail.payment_ref }}</td>
                                    <td>{{ detail.payment_status === 1 ? 'Completed' : 'Pending' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>




</section>